<template>
  <button
    @click="handleClick"
    class="fixed right-4 top-4 flex items-center gap-2 rounded-full bg-[#0A0A0A] px-4 py-2 text-white transition-all duration-300 hover:bg-[#1A1A1A] mt-[14%] z-[99]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :class="{ 'animate-spin': isSpinning }"
    >
      <path d="M21 2v6h-6" />
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M3 22v-6h6" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
    </svg>
    <span class="text-sm">Refresh</span>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import axios from 'axios'

const emit = defineEmits(['refresh'])
const isSpinning = ref(false)

const handleClick = async () => {
  isSpinning.value = true
  try {
    await Promise.all([
      axios.get('https://transfer.popmeme.online/wallets/balance', { withCredentials: true }),
      axios.get('https://transfer.popmeme.online/wallets/holdings', { withCredentials: true })
    ])
    emit('refresh') // Emit refresh event after successful data fetch
  } catch (error) {
    console.error('Error refreshing data:', error)
  } finally {
    setTimeout(() => {
      isSpinning.value = false
    }, 1000) // Stop spinning after 1 second
  }
}
</script> 